import styled from 'styled-components';

export const Root = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.grey(3)};
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacings.abs24}px;
`;
